import React, { useState, useEffect, useRef } from "react";

const RightPanelCard = ({
  isOpen,
  onClose,
  isSmall = false,
  fullHeight = false,
  children,
  enableScroll = false,
}) => {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(false);
  const [topOffset, setTopOffset] = useState("25%");
  const panelRef = useRef(null);

  // Calculate vertical center based on content height
  const calculateTop = () => {
    if (panelRef.current) {
      const panelHeight = panelRef.current.offsetHeight;
      const offset = Math.max((window.innerHeight - panelHeight) / 2, 20); // min 20px from top
      return offset;
    }
    return 20;
  };

  useEffect(() => {
    if (isOpen) {
      setVisible(true);

      // Wait for the panel to render
      setTimeout(() => {
        if (fullHeight) {
          setTopOffset("0px");
        } else {
          setTopOffset(calculateTop() + "px");
        }
        setActive(true);
      }, 10);
    } else {
      setActive(false);
      const timeout = setTimeout(() => setVisible(false), 500);
      return () => clearTimeout(timeout);
    }
  }, [isOpen, children]);

  const handleClose = () => {
    setActive(false);
    setTimeout(() => onClose && onClose(), 500);
  };

  if (!visible) return null;

  return (
    <>
      <div
        className={`right-panel-backdrop ${active ? "active" : ""}`}
        onClick={handleClose}
      />
      <div
        ref={panelRef}
        className={`right-panel ${isSmall && "small-panel"} ${
          active ? "active" : ""
        }`}
        style={{ top: topOffset, height: fullHeight ? "100vh" : "auto" }}
      >
        <div className={enableScroll ? "scrollable" : ""}>{children}</div>
        {/* // when you want to use scrollable add enableScroll */}
      </div>
    </>
  );
};

export default RightPanelCard;
